import React from "react";

export const Contact = () => {
  return (
    <div className="container">
      <h1>Contact</h1>
    </div>
  );
};
